import mitt from "mitt";

/**
 * 登录事件
 */
function LoginEvent() {

  const EVENT_NAME = "@@LoginEvent";

  const emitter = mitt();

  /**
   * 注册事件
   * @param {function} callback 回调函数
   */
  this.on = function (callback) {
    emitter.on(EVENT_NAME, callback);
  };

  /**
   * 触发事件
   * @param {function} param 参数
   */
  this.emit = function (param) {
    emitter.emit(EVENT_NAME, param);
  };

}

export const login = new LoginEvent();

/**
 * 登出事件
 */
function LogoutEvent() {

  const EVENT_NAME = "@@LogoutEvent";

  const emitter = mitt();

  /**
   * 注册事件
   * @param {function} callback 回调函数
   */
  this.on = function (callback) {
    emitter.on(EVENT_NAME, callback);
  };

  /**
   * 触发事件
   * @param {function} param 参数
   */
  this.emit = function (param) {
    emitter.emit(EVENT_NAME, param);
  };

}

export const logout = new LogoutEvent();

/**
 * 切换岗位事件
 */
function SwitchPositionEvent() {

  const EVENT_NAME = "@@SwitchPositionEvent";

  const emitter = mitt();

  /**
   * 注册事件
   * @param {function} callback 回调函数
   */
  this.on = function (callback) {
    emitter.on(EVENT_NAME, callback);
  };

  /**
   * 触发事件
   * @param {function} param 参数
   */
  this.emit = function (param) {
    emitter.emit(EVENT_NAME, param);
  };

}

export const switchPosition = new SwitchPositionEvent();
